/**
 * @file 検索項目「移籍状況」変更時の処理
 *
 */
'use strict'

/**
 * @classname ChangeSearchItemTransferStatus
 * @classdesc 検索項目「移籍状況」変更時の処理
 */
export default class ChangeSearchItemTransferStatus {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.search-item-transfer-status')
	 */
	constructor($e) {
		console.log('ChangeSearchItemTransferStatus.constructor')
		this._$e = $e
		this._$searchItemTransferTask = $('.search-item-transfer-task')
		this._$e.on('change', () => this.onChange())
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeSearchItemTransferStatus
	 * @return {undefined}
	 */
	onChange() {
		console.log('ChangeSearchItemTransferStatus.onChange')
		this._$e.val() !== '' ? this._$searchItemTransferTask.prop('disabled', true) : this._$searchItemTransferTask.prop('disabled', false)
	}
}
